import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '@common/services';
import { UserService } from '@modules/auth/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-referrals',
    templateUrl: './referrals.component.html',
    styleUrls: ['./referrals.component.scss'],
})
export class ReferralsComponent implements OnInit, OnDestroy {
    /** tenantId del usuario logueado (alimenta el panel reutilizable). */
    tenantId: string | null = null;

    constructor(public activeModal: NgbActiveModal, private userService: UserService, private analyticsService: AnalyticsService) {}

    ngOnInit(): void {
        this.userService.user$.pipe(take(1)).subscribe(user => {
            this.tenantId = user?.tenantId ?? null;
        });
    }

    /** Captura el cierre del modal en cualquiera de sus formas (cruz, ESC, backdrop, dismissAll). */
    ngOnDestroy(): void {
        this.analyticsService.analyticsCapture('referral_modal_dismissed', { origin: 'web' });
    }
}
